var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-label", {
    attrs: {
      label: _vm.label,
      "class-name": _vm.formLabelClassName,
      "is-required": _vm.isRequired,
      "form-class-name": _vm.formClassName,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "label",
          fn: function () {
            return [_vm._t("label")]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [_vm._t("header")]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c("star-rating", {
                attrs: {
                  "active-color": "#1BB2B1",
                  "inactive-color": "#FFFFFF",
                  "star-size": 25,
                  "border-width": 2,
                  "rounded-corners": true,
                  "show-rating": false,
                  "read-only": _vm.readOnly,
                  "data-test": "star-rating",
                },
                model: {
                  value: _vm.ratingValue,
                  callback: function ($$v) {
                    _vm.ratingValue = $$v
                  },
                  expression: "ratingValue",
                },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "error",
          fn: function () {
            return [
              _vm._t("error"),
              _vm._v(" "),
              _vm.validation.isShow
                ? _c("validation-label", {
                    attrs: {
                      "data-test": "error",
                      label: _vm.validation.message,
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }